import React from 'react';
import { Outlet } from 'react-router-dom';
import { useIsAuthenticated } from 'services/useAuth';
import { Spin } from 'antd';

const PublicRoute: React.FC = () => {
  const { isAuthenticated, initialized, validating } = useIsAuthenticated();

  if (!initialized || validating) {
    return <Spin size="large" />;
  }

  if (isAuthenticated) {
    // const redirectPath = localStorage.getItem('redirect_path') || '/';
    // localStorage.removeItem('redirect_path');
    // return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
